







import Vue from 'vue';
import type { PropOptions } from 'vue';
import HeaderMenuNotificationsCardGrid from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGrid.vue';
import { referenceableTypes } from '@/components/global/HeaderMenu/HeaderMenuNotifications/constants';
import type { Notification, User, Comment, Post } from '@/types/graphql';
import { Anonymous } from '@/types/graphql';

export default Vue.extend({
  name: 'HeaderMenuNotificationsCardMention',
  components: {
    HeaderMenuNotificationsCardGrid,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    } as PropOptions<Notification>,
  },
  computed: {
    referenceable(): Comment & Post {
      return this.notification.referenceable as Comment & Post;
    },
    userTitle(): string {
      if (this.referenceable.author.__typename == 'Public') {
        return `${this.referenceable.author.firstname} ${this.referenceable.author.lastname}`;
      }
      return (this.referenceable.author as Anonymous).username ?? '';
    },
    reactableText(): string {
      return this.referenceable.__typename === referenceableTypes.POST ? this.postText : this.commentText;
    },
    commentText(): string {
      if (this.referenceable.deletedAt) {
        return 'Comment has been deleted by the author';
      }

      return this.referenceable.text;
    },
    postText(): string {
      return this.referenceable.content.title;
    },
    referenceableType(): string {
      const type = this.referenceable.__typename;
      return type ? (type as string).toLowerCase() : '';
    },
  },
});
